import { css } from '@fable/theme'
import { useStats } from '../lib/ctx/stats'
import { usePreloadImage } from '@fable/hooks'

interface Props {
  size?: string
  imageSize?: number
}

export const StatsUserImage = ({ size = '92px', imageSize = 200 }: Props) => {
  const [stats, theme] = useStats((s) => [s.stats, s.theme])
  const userImg = stats?.user?.pic_resize || ''
  const avatar = usePreloadImage(userImg, imageSize)

  if (!stats?.user || !avatar?.src?.length)
    return (
      <span
        className={css`
          display: block;
          width: ${size};
          height: ${size};
          background-color: ${theme.accent}40;
          border-radius: 50%;
        `}
      />
    )

  return (
    <img
      className={css`
        display: block;
        width: ${size};
        height: ${size};
        background-color: ${theme.accent}40;
        object-fit: cover;
        object-position: center;
        border-radius: 50%;
        overflow: hidden;
      `}
      src={`${avatar?.src}&mode=cors`}
      alt={`${stats?.user.display_name}'s avatar`}
    />
  )
}
